<template>
  <div>
    <VueGoodTable
      mode="remote"
      @on-page-change="onPageChange"
      @on-sort-change="onSortChange"
      @on-per-page-change="onPerPageChange"
      @on-search="onSearch"
      :isLoading.sync="isLoading"
      :columns="columns"
      :rows="users"
      :totalRows="totalRecords"
      :line-numbers="false"
      :search-options="{
        enabled: true,
        placeholder: 'Tìm kiếm',
      }"
      :pagination-options="{
        enabled: true,
        mode: 'records',
        rowsPerPageLabel: 'Số hàng mỗi trang',
        nextLabel: 'Trang sau',
        prevLabel: 'Trang trước',
        ofLabel: 'trong',
      }"
      styleClass="vgt-table striped bordered"
    >
      >

      <div slot="emptystate">Danh sách người dùng trống</div>
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field === 'active'">
          <UserActiveStatusTag :user="props.row" />
        </span>
        <span v-else-if="props.column.field === 'pricingPlan'">
          <PricingPlanTag :name="props.row.subscription.plan.name" />
        </span>
        <span v-else-if="props.column.field === 'credit'">
          <span
            ><b>{{ formatNumber(props.row.credit.checkAttempt) }}</b> lượt</span
          >
          <br />
          <span
            ><b>{{ formatNumber(props.row.credit.credit) }}</b> trang</span
          >
        </span>
        <div v-else-if="props.column.field === 'action'" class="flex-center table-action-container">
          <FAIcon
            icon="fas fa-info-circle"
            :color="Colors.INFO"
            @click="$refs[refs.USER_INFO_MODAL].showModal(props.row)"
            title="Thông tin tài khoản"
          />

          <FAIcon
            icon="fas fa-fire"
            :color="Colors.BLUE"
            @click="$refs[refs.EDIT_USER_CREDIT_MODAL].showModal(props.row)"
            title="Thay đổi lượng kiểm tra"
          />
          <FAIcon
            icon="fas fa-pen-nib"
            :color="Colors.EDIT"
            @click="$refs[refs.EDIT_USER_MODAL].showModal(props.row)"
            title="Thay đổi lượng kiểm tra"
          />

          <el-dropdown trigger="hover" :show-timeout="0">
            <div>
              <FAIcon icon="el-icon-more" />
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <div @click="$refs[refs.EDIT_USER_MODAL].showModal(props.row)">
                  <FAIcon icon="fas fa-pen-nib" :color="Colors.EDIT" />
                  Chỉnh sửa
                </div>
              </el-dropdown-item>
              <el-dropdown-item>
                <div @click="$refs[refs.PASSWORD_RESET_MODAL].showModal(props.row)">
                  <FAIcon icon="fas fa-key" :color="Colors.BLACK" />
                  Đổi mật khẩu
                </div>
              </el-dropdown-item>
              <el-dropdown-item v-if="!props.row.anonymousEmail">
                <div @click="$refs[refs.CHANGE_EMAIL_ACTIVE_STATUS_MODAL].showModal(props.row)">
                  <FAIcon
                    :icon="props.row.emailConfirmed ? 'fas fa-envelope' : 'fas fa-check'"
                    :color="props.row.emailConfirmed ? Colors.DELETE : Colors.SUCCESS"
                  />
                  {{ props.row.emailConfirmed ? 'Bỏ xác nhận email' : 'Xác nhận email' }}
                </div>
              </el-dropdown-item>
              <el-dropdown-item>
                <div @click="$refs[refs.CHANGE_ACTIVE_STATUS_MODAL].showModal(props.row)">
                  <FAIcon
                    :icon="props.row.active ? 'fas fa-ban' : 'fas fa-check'"
                    :color="props.row.active ? Colors.DELETE : Colors.SUCCESS"
                  />
                  {{ props.row.active ? 'Khóa tài khoản' : 'Kích hoạt' }}
                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <span v-else-if="props.column.field === 'name'">
          {{ props.row.name }}<br />
          {{ props.row.email }}
<!--          <FAIcon v-if="props.row.anonymousEmail" icon="fas fa-mask" :color="Colors.INFO" title="Email ảo" />-->
          <FAIcon
            v-if="!props.row.emailConfirmed"
            icon="fas fa-exclamation-triangle"
            :color="Colors.DELETE"
            title="Chưa xác nhận email"
          />
        </span>
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <template slot="loadingContent">
        <span class="vgt-loading__content"> Đang tải... </span>
      </template>
    </VueGoodTable>
    <PasswordResetAdminModal :ref="refs.PASSWORD_RESET_MODAL" />
    <EditUserModal :ref="refs.EDIT_USER_MODAL" @success="loadItems" />
    <ChangeEmailActiveStatusModal :ref="refs.CHANGE_EMAIL_ACTIVE_STATUS_MODAL" @success="loadItems" />
    <ChangeActiveStatusModal :ref="refs.CHANGE_ACTIVE_STATUS_MODAL" @success="loadItems" />
    <UserDetailInfoModal :ref="refs.USER_INFO_MODAL" />
    <EditUserCreditModal :ref="refs.EDIT_USER_CREDIT_MODAL" @success="loadItems" />
  </div>
</template>

<script>
import { VueGoodTable } from 'vue-good-table'
import '@/assets/css/vue-good-table.css'
import 'moment/locale/vi'
import { apiGetAllUser } from '@/services/user_service'
import { DownloadType, Table } from '@/constants/DoITConstant'
import { formatDate } from '@/helpers/timeHelper.js'
import { Colors } from '@/constants/DoITConstant.js'
import FAIcon from '@/components/common/FAIcon.vue'
import UserActiveStatusTag from '@/components/dashboard/user/UserActiveStatusTag.vue'
import PricingPlanTag from '@/components/common/PricingPlanTag.vue'
import PasswordResetAdminModal from '@/components/dashboard/user/action-modals/PasswordResetAdminModal.vue'
import EditUserModal from '@/components/dashboard/user/action-modals/EditUserModal.vue'
import ChangeAnonymousEmailModal from '@/components/dashboard/user/action-modals/ChangeAnonymousEmailModal.vue'
import ChangeActiveStatusModal from '@/components/dashboard/user/action-modals/ChangeActiveStatusModal.vue'
import ChangeEmailActiveStatusModal from '@/components/dashboard/user/action-modals/ChangeEmailActiveStatusModal.vue'
import UserDetailInfoModal from '@/components/dashboard/user/action-modals/UserDetailInfoModal.vue'
import { formatNumber } from '@/helpers/numberUtils.js'
import EditUserCreditModal from '@/components/dashboard/user/action-modals/EditUserCreditModal.vue'

export default {
  name: 'UserList',
  components: {
    EditUserCreditModal,
    UserDetailInfoModal,
    ChangeEmailActiveStatusModal,
    ChangeActiveStatusModal,
    ChangeAnonymousEmailModal,
    EditUserModal,
    PasswordResetAdminModal,
    PricingPlanTag,
    UserActiveStatusTag,
    VueGoodTable,
    FAIcon,
  },
  props: {},
  data: function () {
    return {
      columns: [],
      DownloadType: DownloadType,
      totalRecords: 0,
      serverParams: {
        sortAscending: false,
        sortField: 'createTime',
        page: 0,
        size: 10,
      },
      users: [],
      interval: null,
      isLoading: true,
      formatDate,
      formatNumber,
      Colors,
      refs: {
        USER_INFO_MODAL: 'USER_INFO_MODAL',
        EDIT_USER_MODAL: 'EDIT_USER_MODAL',
        EDIT_USER_CREDIT_MODAL: 'EDIT_USER_CREDIT_MODAL',
        PASSWORD_RESET_MODAL: 'PASSWORD_RESET_MODAL',
        CHANGE_ACTIVE_STATUS_MODAL: 'CHANGE_ACTIVE_STATUS_MODAL',
        CHANGE_EMAIL_ACTIVE_STATUS_MODAL: 'CHANGE_EMAIL_ACTIVE_STATUS_MODAL',
      },
    }
  },
  mounted() {
    this.columns = [
      {
        label: 'id',
        field: 'id',
      },
      {
        label: 'Họ tên',
        field: 'name',
      },
      {
        label: 'Ngày tạo',
        field: 'createTime',
        formatFn: formatDate,
      },
      {
        label: 'Hạn SD',
        field: (rowObj) => rowObj.subscription.to,
        formatFn: formatDate,
      },
      {
        label: 'Trạng thái',
        field: 'active',
      },
      {
        label: 'Loại tài khoản',
        field: 'pricingPlan',
      },
      {
        label: 'Credit',
        field: 'credit',
      },
      {
        label: 'Hành động',
        field: 'action',
      },
    ]

    this.loadItems()
    this.interval = setInterval(() => {
      this.loadItems()
    }, Table.RELOAD_INTERVAL)
  },
  destroyed() {
    clearInterval(this.interval)
  },
  methods: {
    onSearch(params) {
      this.serverParams.searchKey = params.searchTerm
      this.loadItems()
    },

    onPageChange(params) {
      this.serverParams.page = params.currentPage - 1
      this.loadItems()
    },

    onPerPageChange(params) {
      this.serverParams.size = params.currentPerPage
      this.loadItems()
    },

    onSortChange(params) {
      this.serverParams.sortAscending = params[0].type === 'asc'
      this.serverParams.sortField = params[0].field
      this.serverParams.page = 0
      this.loadItems()
    },
    async loadItems() {
      this.isLoading = true
      let responseAllUser = await apiGetAllUser(this.serverParams)
      this.users = responseAllUser.data
      this.totalRecords = responseAllUser.meta.total
      this.isLoading = false
    },
  },
}
</script>

<style lang="scss">
.table-action-container {
  * {
    margin: 1px;
  }
}
</style>
